import { render, staticRenderFns } from "./OperationTypeRestoreContainer.vue?vue&type=template&id=59c15584"
import script from "./OperationTypeRestoreContainer.vue?vue&type=script&lang=js"
export * from "./OperationTypeRestoreContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports